/**
 * Flag "ya se explicó el permiso de ubicación" (004 · US6 · T067; FR-003, US6 AC6; research R-26).
 *
 * *"La primera vez que se solicita ubicación, aparece el permiso, Staff explica antes"* — una sola
 * vez por sesión, igual criterio y mismo patrón que `notice-store.ts` y
 * `features/access/privacy-store.ts`. Pedir la ubicación en sí **nunca espera** a que el
 * trabajador cierre esta hoja (R-24): la hoja es puramente informativa y no bloqueante.
 */
import { useSyncExternalStore } from 'react';

export const LOCATION_EXPLAINED_KEY = 'fermin:location-explained';

const listeners = new Set<() => void>();

function readExplained(): boolean {
  try {
    return globalThis.sessionStorage?.getItem(LOCATION_EXPLAINED_KEY) === '1';
  } catch {
    return false;
  }
}

let explained = readExplained();

export function hasExplainedLocation(): boolean {
  return explained;
}

export function setLocationExplained(value: boolean): void {
  if (explained === value) {
    return;
  }
  explained = value;
  try {
    if (value) {
      globalThis.sessionStorage?.setItem(LOCATION_EXPLAINED_KEY, '1');
    } else {
      globalThis.sessionStorage?.removeItem(LOCATION_EXPLAINED_KEY);
    }
  } catch {
    // Sin almacenamiento (modo privado estricto): el flag vive solo en memoria.
  }
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeLocationExplained(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useLocationExplained(): boolean {
  return useSyncExternalStore(subscribeLocationExplained, hasExplainedLocation, () => false);
}
